import { GenericDropdownOption } from '../App.types';
import countries from './countries';

export const countryOptions: GenericDropdownOption<string>[] = Object.entries(countries).map(([code, name]) => ({
    value: code,
    label: name,
}));

export const DEFAULT_INITIAL_PAGE_SIZE_OPTION: GenericDropdownOption<number> = {
    label: '10',
    value: 10,
};

// Values must match AVG_VIEWS_BUCKET_DAYS in the backend — they are the `bucket` query param
// and the keys of the cached buckets JSON.
export const DEFAULT_AVG_VIEWS_BUCKET_OPTION: GenericDropdownOption<string> = {
    value: '90-days',
    label: 'Last 90 days',
};

export const AVG_VIEWS_BUCKET_OPTIONS: GenericDropdownOption<string>[] = [
    { value: '7-days', label: 'Last 7 days' },
    { value: '10-days', label: 'Last 10 days' },
    { value: '14-days', label: 'Last 14 days' },
    { value: '30-days', label: 'Last 30 days' },
    DEFAULT_AVG_VIEWS_BUCKET_OPTION,
    { value: 'all-time', label: 'All time' },
];

export const DEFAULT_AVG_VIEWS_BUCKET = DEFAULT_AVG_VIEWS_BUCKET_OPTION.value;

export const defaultPageSizeOptions: GenericDropdownOption<number>[] = [
    DEFAULT_INITIAL_PAGE_SIZE_OPTION,
    { label: '25', value: 25 },
    { label: '35', value: 35 },
    { label: '50', value: 50 },
];

export const getPageSizeOptions = (pageSizes: number[]): GenericDropdownOption<number>[] =>
    pageSizes.map((size) => ({ value: size, label: size.toString() }));

export const MAX_PAYPAL_API_PAYMENT_AMOUNT = 1000;
export const MEGA_BYTE = 1_000_000;
export const SUPPORTED_IMAGE_EXTENSIONS = '.jpg, .jpeg, .png, .webp, .avif';
